export interface RoundingSettings {
  displayPrecision: number;
  roundingPolicy: RoundingPolicy;
  aggregationRoundingPolicy: AggregationRoundingPolicy;
  showStorageHint: boolean;
  roundingTolerance: number;
  autoRecalculateOnPriceChange: boolean;
}

export interface RoundingConfiguration {
  basedOnId: number;
  basedOnType: BasedOnType;
  roundingSettings: RoundingSettings;
}

export interface RoundingConfigurationResponse {
  statusCode: string;
  data: RoundingConfiguration;
  succeeded: boolean;
  errorCode: string;
  errors: string[];
  message: string;
  referenceNumber: string;
  correlationId: string;
  elapsedTime: number;
}

export enum RoundingPolicy {
  Nearest = 'Nearest',
  Up = 'Up',
  Down = 'Down'
}

export enum AggregationRoundingPolicy {
  AggregateThenRound = 'AggregateThenRound',
  RoundThenAggregate = 'RoundThenAggregate'
}

export enum BasedOnType {
  Branch = 'Branch',
  Store = 'Store',
  Company = 'Company',
  GlAccount = 'GlAccount',
  Document = 'Document',
  PageType = 'PageType',
  Page = 'Page',
  Module = 'Module',
  Tarmeez = 'Tarmeez',
  User = 'User',
  Role = 'Role',
  Employee = 'Employee'
}

export interface UpdateRoundingConfigurationRequest {
  basedOnType: BasedOnType;
  basedOnId: number;
  roundingSettings: RoundingSettings;
}
